export default function CoachTeamMemberProfile() {
  return <h1>This is Coach Team Member Profile</h1>;
}
